import React from 'react';
import { Fit, Layout, useRive } from '@rive-app/react-webgl2';
import file from '../../../../assets/NewGradientBG.png';

export const RiveBackground = () => {
  const { RiveComponent } = useRive({
    src: file,
    autoplay: true,
    layout: new Layout({
      fit: Fit.Cover,
      // layoutScaleFactor: 2, // 2x scale of the layout, when using `Fit.Layout`. This allows you to resize the layout as needed.
    }),
  });

  return <RiveComponent />;
};
